// Explore opens on the tab this browser tab last showed. The browser remembers the
// tab Explore renders and sends it with every Turbo request, so a link or redirect
// that lands on Explore without a tab gets that tab in the first response.
const KEY = 'exploreTab';

const rememberExploreTab = function rememberExploreTab() {
  const storeRenderedTab = () => {
    const tab = document.querySelector('[data-explore-tab]')?.dataset.exploreTab;
    if (!tab) return;

    // sessionStorage keeps each browser tab's own choice; localStorage seeds new ones.
    sessionStorage.setItem(KEY, tab);
    localStorage.setItem(KEY, tab);
  };

  document.addEventListener('turbo:load', storeRenderedTab);
  document.addEventListener('turbo:frame-load', storeRenderedTab);

  document.addEventListener('turbo:before-fetch-request', ({ detail }) => {
    const tab = sessionStorage.getItem(KEY) || localStorage.getItem(KEY);
    if (tab) detail.fetchOptions.headers['X-Explore-Tab'] = tab;
  });
};

export default rememberExploreTab;
